import React, { useMemo, useRef } from 'react'
import { Flex } from '@airbus/components-react/components'
import FormInput from 'components/FormFields/FormInput'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import tools from 'utils/helpers'
import myLocalStorage from 'utils/myLocalStorage'
import ComponentsUNames from 'constants/componentsUNames'

type Props = {
  jobState: 'done' | 'not done' | 'HIL'
  readOnly?: boolean
  executing?: boolean
  editing?: boolean
}

const WoWorkForm = ({ jobState, executing = false, readOnly = false, editing = false }: Props) => {
  const {
    formState: { errors },
    watch,
  } = useFormContext()
  const { t } = useTranslation()
  const requestWorkRef = useRef(null)
  const performedWorkRef = useRef(null)

  // Permissions for editing the fields
  const canEditRequestedWork = myLocalStorage.getOrDefault(
    [myLocalStorage.KEY_PERMISSIONS, ComponentsUNames.WORKORDER_UPDATE_TD],
    myLocalStorage.VALUE_TYPE.BOOLEAN,
    false,
  )
  const canEditPerformedWork = myLocalStorage.getOrDefault(
    [myLocalStorage.KEY_PERMISSIONS, ComponentsUNames.WORKORDER_UPDATE_TE],
    myLocalStorage.VALUE_TYPE.BOOLEAN,
    false,
  )

  const requestedWork = watch('requestedWork')
  const performedWork = watch('performedWork')

  const requestedWorkRows = useMemo(
    () => tools.getTextAreaRows(requestedWork, requestWorkRef),
    [requestedWork, requestWorkRef],
  )
  const performedWorkRows = useMemo(
    () => tools.getTextAreaRows(performedWork, requestWorkRef),
    [performedWork, requestWorkRef],
  )

  if (executing && !jobState) return null

  return (
    <Flex
      style={{ width: '100%' }}
      childrenStyle={{ flex: 1 }}
      direction={jobState === 'done' ? 'row' : 'column'}
      spacing='2-x'
    >
      <div ref={requestWorkRef}>
        <FormInput
          name='requestedWork'
          label={t('2MOE097')}
          rules={{ required: !(readOnly || executing || !canEditRequestedWork) }}
          multiline
          rows={requestedWorkRows}
          placeholder={t('2MOE097') as string}
          readOnly={readOnly || executing || !canEditRequestedWork}
          error={Boolean(errors.requestedWork)}
          style={{ flexBasis: '50%' }}
        />
      </div>
      {((executing && ['done', 'HIL'].includes(jobState)) || editing || readOnly) && (
        <div ref={performedWorkRef}>
          <FormInput
            name='performedWork'
            label={t('2MOE098')}
            multiline
            rows={performedWorkRows}
            placeholder={t('2MOE098') as string}
            readOnly={readOnly || !canEditPerformedWork}
            error={Boolean(errors.performedWork)}
            rules={{ required: executing && canEditPerformedWork && jobState === 'done' }}
            style={{
              flexBasis: '50%',
              marginLeft: jobState === 'done' ? '1em' : '',
              marginTop: jobState === 'done' ? '' : '1em',
            }}
          />
        </div>
      )}
    </Flex>
  )
}

export default WoWorkForm
